(function() {
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
  }

  function getTikTokClickId() {
    const urlParams = new URLSearchParams(window.location.search);
    const clickId = urlParams.get('ttclid') || getCookie('ttclid');
    return clickId || '';
  }

  function logTrackingData(source = 'periodic check') {
    const externalIds = {
      ttclid: [
        getTikTokClickId(),
        getCookie('ttclid'),
        getCookie('_ttclid'),
        localStorage.getItem('ttclid'),
        new URLSearchParams(window.location.search).get('ttclid')
      ],
      fbclid: [
        getCookie('_fbc'),
        getCookie('_fbp'),
        new URLSearchParams(window.location.search).get('fbclid')
      ],
      gclid: [
        getCookie('_gac'),
        new URLSearchParams(window.location.search).get('gclid')
      ],
      msclkid: [
        new URLSearchParams(window.location.search).get('msclkid')
      ]
    };

    const emailSources = {
      'Window Customer Data': window.customerData?.email,
      'Shopify Customer': window._customer?.email,
      'Meta Customer': window.meta?.page?.customer?.email,
      'Checkout Email': window.Shopify?.checkout?.email,
      'Local Storage': localStorage.getItem('last_known_email'),
      'Session Storage': sessionStorage.getItem('customer_email'),
      'Form Fields': Array.from(document.querySelectorAll('input[type="email"]')).map(input => input.value).filter(Boolean),
      'Hidden Fields': Array.from(document.querySelectorAll('input[type="hidden"]')).filter(input => input.value?.includes('@')).map(input => input.value)
    };

    const phoneSources = {
      'Window Customer Data': window.customerData?.phone,
      'Shopify Customer': window._customer?.phone,
      'Meta Customer': window.meta?.page?.customer?.phone,
      'Local Storage': localStorage.getItem('last_known_phone'),
      'Form Fields': Array.from(document.querySelectorAll('input[type="tel"]')).map(input => input.value).filter(Boolean),
      'Cookies': [
        getCookie('customer_phone'),
        getCookie('_shop_phone'),
        getCookie('phone')
      ].filter(Boolean)
    };
  }

  async function getIPAddress() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (e) {
      return undefined;
    }
  }

  function getCustomerEmail() {
    const possibleEmailSources = [
      window.customerData?.email,
      window._customer?.email,
      window.meta?.page?.customer?.email,
      window.Shopify?.checkout?.email,
      window.ShopifyCustomer?.email,
      window.cart?.email,
      window.checkout?.email,
      window.__st?.cid,
      window.meta?.page?.customerId,
      localStorage.getItem('customer_email'),
      localStorage.getItem('email'),
      localStorage.getItem('last_known_email'),
      localStorage.getItem('shopify_customer_email'),
      localStorage.getItem('_email'),
      localStorage.getItem('checkout.email'),
      localStorage.getItem('remembered_email'),
      sessionStorage.getItem('customer_email'),
      sessionStorage.getItem('email'),
      sessionStorage.getItem('checkout_email'),
      getCookie('_email'),
      getCookie('customer_email'),
      getCookie('shopify_customer_email'),
      getCookie('_shopify_customer_email'),
      getCookie('checkout_email'),
      getCookie('remembered_email'),
      getCookie('cart_email'),
      getCookie('newsletter_email'),
      getCookie('signup_email'),
      getCookie('account_email'),
      getCookie('guest_email'),
      getCookie('_gc_customer_email'),
      getCookie('klaviyo_email'),
      getCookie('subscriber_email'),
      ...Array.from(document.querySelectorAll('input[type="email"], input[name*="email"], input[id*="email"]'))
        .map(input => input.value),
      ...Array.from(document.querySelectorAll('input[type="hidden"]'))
        .filter(input => input.value?.includes('@'))
        .map(input => input.value),
      ...Array.from(document.querySelectorAll('[data-customer-email], [data-email]'))
        .map(el => el.dataset.customerEmail || el.dataset.email),
      new URLSearchParams(window.location.search).get('email'),
      new URLSearchParams(window.location.search).get('customer_email'),
      document.querySelector('meta[name="customer-email"]')?.content,
      document.querySelector('meta[property="customer:email"]')?.content
    ];

    return possibleEmailSources
      .filter(Boolean)
      .find(email => email.includes('@') && email.includes('.')) || '';
  }

  function getCustomerPhone() {
    const possiblePhoneSources = [
      window.customerData?.phone,
      window._customer?.phone,
      window.meta?.page?.customer?.phone,
      window.Shopify?.checkout?.phone,
      window.ShopifyCustomer?.phone,
      window.cart?.phone,
      window.checkout?.phone,
      localStorage.getItem('customer_phone'),
      localStorage.getItem('phone'),
      localStorage.getItem('last_known_phone'),
      localStorage.getItem('shopify_customer_phone'),
      localStorage.getItem('_phone'),
      localStorage.getItem('checkout.phone'),
      localStorage.getItem('remembered_phone'),
      sessionStorage.getItem('customer_phone'),
      sessionStorage.getItem('phone'),
      sessionStorage.getItem('checkout_phone'),
      getCookie('_phone'),
      getCookie('customer_phone'),
      getCookie('shopify_customer_phone'),
      getCookie('_shopify_customer_phone'),
      getCookie('checkout_phone'),
      getCookie('remembered_phone'),
      getCookie('cart_phone'),
      getCookie('account_phone'),
      getCookie('guest_phone'),
      getCookie('_gc_customer_phone'),
      getCookie('phone_number'),
      getCookie('contact_phone'),
      ...Array.from(document.querySelectorAll('input[type="tel"], input[name*="phone"], input[id*="phone"]'))
        .map(input => input.value),
      ...Array.from(document.querySelectorAll('input[type="hidden"]'))
        .filter(input => input.value?.match(/^\+?[\d\s-()]{10,}$/))
        .map(input => input.value),
      ...Array.from(document.querySelectorAll('[data-customer-phone], [data-phone]'))
        .map(el => el.dataset.customerPhone || el.dataset.phone),
      new URLSearchParams(window.location.search).get('phone'),
      new URLSearchParams(window.location.search).get('customer_phone'),
      document.querySelector('meta[name="customer-phone"]')?.content,
      document.querySelector('meta[property="customer:phone"]')?.content
    ];

    const phones = possiblePhoneSources
      .filter(Boolean)
      .map(phone => {
        try {
          const cleaned = phone.toString().replace(/\D/g, '');
          if (cleaned.length === 10) {
            return `+1${cleaned}`;
          } else if (cleaned.length > 10) {
            return `+${cleaned}`;
          } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
            return `+${cleaned}`;
          }
          return null;
        } catch (e) {
          return null;
        }
      })
      .filter(Boolean);

    return phones[0] || '';
  }

  function monitorForms() {
    const formInputHandler = (e) => {
      const input = e.target;
      const value = input.value;

      if (!value) return;

      if (input.type === 'email' || input.name?.includes('email') || input.id?.includes('email')) {
        if (value.includes('@') && value.includes('.')) {
          localStorage.setItem('last_known_email', value);
        }
      }

      if (input.type === 'tel' || input.name?.includes('phone') || input.id?.includes('phone')) {
        const cleaned = value.replace(/\D/g, '');
        if (cleaned.length >= 10) {
          localStorage.setItem('last_known_phone', value);
        }
      }
    };

    document.addEventListener('input', formInputHandler);
    document.addEventListener('change', formInputHandler);
  }

  monitorForms();

  window.sendAddToCartEvent = async function(eventData = {}) {
    try {
      const email = getCustomerEmail();
      const phone = getCustomerPhone();
      const ip = await getIPAddress();
      const clickId = getTikTokClickId();

      // const eventParams = {
      //   event: "AddToCart",
      //   event_id: `sh-${Math.random().toString(36).substr(2, 32)}`,
      //   context: {
      //     ad: { sdk_env: "external", jsb_status: 2 },
      //     device: { platform: "pc" }
      //   },
      //   is_onsite: false,
      //   message_id: `messageId-${Date.now()}-${Math.random().toString(36).substr(2, 16)}`,
      //   properties: {
      //     email,
      //     phone_number: phone,
      //     ip_address: ip,
      //     ttclid: clickId,
      //     event: "AddToCart",
      //     partner: "Shopify",
      //     content_id: eventData.variantId,
      //     content_name: eventData.productTitle,
      //     content_type: "product_group",
      //     currency: "USD",
      //     price: eventData.price || null,
      //     quantity: eventData.quantity || 1,
      //     brand: "Memorialize",
      //     timestamp: new Date().toISOString()
      //   }
      // };

      const actualCurrency = window.SHOP_CURRENCY || 'USD';
      // ttq.track('AddToCart', eventParams);
      ttq.track('AddToCart', {
        content_id: eventData.variantId,
        content_name: eventData.productTitle,
        content_type: 'product',
        currency: actualCurrency,
        value: eventData.price ? (eventData.price / 100) * (eventData.quantity || 1) : 0,
        quantity: eventData.quantity || 1,
        contents: [{
          content_id: eventData.variantId,
          content_type: 'product',
          quantity: eventData.quantity || 1,
          price: eventData.price ? eventData.price / 100 : 0
        }]
      });
      logTrackingData('after add to cart event');
    } catch (error) {}
  };

  // document.addEventListener('click', function(e) {
  //   if (e.target.matches('button[name="add"]') || e.target.closest('form[action="/cart/add"]')) {
  //     const productForm = e.target.closest('form[action="/cart/add"]');
  //     if (productForm) {
  //       alert("Old functional: start TikTok pixel")
  //       sendAddToCartEvent({
  //         variantId: productForm.querySelector('[name="id"]')?.value,
  //         quantity: parseInt(productForm.querySelector('[name="quantity"]')?.value || 1),
  //         price: window.meta?.product?.price,
  //         productTitle: window.meta?.product?.title
  //       });
  //     }
  //   }
  // });

  // new trigger to pixel AR 17.11.2025 Fix TikTok Pixel AddToCart Trigger
  const originalFetch = window.fetch;
  window.fetch = async function(resource, config) {
    const isAddToCart = typeof resource === 'string' && resource.includes('/cart/add');

    const response = await originalFetch(resource, config);

    if (isAddToCart && response.ok) {
      try {
        const cloned = response.clone();
        const data = await cloned.json();

        if (data && data.id) {
          
          sendAddToCartEvent({
            variantId: data.variant_id || data.id,
            quantity: data.quantity || 1,
            price: data.price,  
            productTitle: data.title
          });
        }
      } catch (e) {}
    }

    return response;
  };


  
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      logTrackingData('URL change');
    }
  }).observe(document, { subtree: true, childList: true });

  window.debugTracking = logTrackingData;
  logTrackingData('initial load');
})();